module.exports = __webpack_public_path__ + "static/media/image.f37e9ce6.jpg";